import { message } from 'ant-design-vue'
import _ from 'lodash'
import {getLocalStorage, setLocalStorage} from '../../utils/storage'
const state = {
  views: getLocalStorage('VIEWS') || {}
}

const mutations = {
  SAVE_VIEW: (state: any, { route, view }: any) => {
    if (!state.views[route] || state.views[route].length < 1) {
      message.info('请先新增一个视图')
      return
    }
    for (let i = 0; i < state.views[route].length; i++) {
      if (state.views[route][i].id === view.id) {
        const newViews = _.cloneDeep(state.views)
        newViews[route][i] = view
        state.views = newViews
        setLocalStorage('VIEWS', state.views)
        message.success('保存视图成功')
        return
      }
    }
    message.info('请先选择一个视图')
  },
  CREATE_VIEW: (state: any, { route, view }: any) => {
    if (!state.views[route] || state.views[route].length < 1) {
      state.views[route] = []
    }
    const newViews = _.cloneDeep(state.views)
    newViews[route] = newViews[route].concat(view)
    state.views = newViews
    setLocalStorage('VIEWS', state.views)
    message.success('新增视图成功')
  },
  DELETE_VIEW: (state: any, { route, view }: any) => {
    state.views[route] = state.views[route].filter((v : any) => v.id !== view.id)
    setLocalStorage('VIEWS', state.views)
  }
}

const actions = {
  saveView({ commit }: any, { route, view }: any) {
    return new Promise(resolve => {
      commit('SAVE_VIEW', { route, view })
      resolve()
    })
  },
  createView({ commit }: any, payload: any) {
    console.log(payload)
    const { route, view } = payload
    return new Promise(resolve => {
      commit('CREATE_VIEW', { route, view })
      resolve()
    })
  },
  deleteView({ commit }: any, { route, view }: any) {
    return new Promise(resolve => {
      commit('DELETE_VIEW', { route, view })
      resolve()
    })
  }
}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
